import Icon from '../components/Icon.vue'

Icon.register({
  'house-damage': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 115l218.7 192.9c1.5 1.4 3.6 2 5.3 3.2v184.9c0 8.8-7.2 16-16 16h-176.2l-39.9-55.3 104.1-64-148.1-136.8 60.2 119.2-104.1 64 37.2 72.8h-149.2c-8.8 0-16-7.2-16-16v-184.9c1.8-1.2 3.8-1.9 5.5-3.3zM570.7 236.3c6.6 5.9 7.1 16 1.2 22.6l-21.4 23.8c-5.9 6.6-16 7.1-22.6 1.2l-229.3-202.3c-6-5.3-15.1-5.3-21.2 0l-229.3 202.3c-6.6 5.9-16.7 5.4-22.6-1.2l-21.4-23.8c-5.9-6.6-5.4-16.7 1.2-22.6l256-226c7.6-6.9 17.1-10.3 26.7-10.3s19.1 3.5 26.8 10.3l101.3 89.4v-51.7c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v136.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/house-damage.js
// module id = 1472
// module chunks = 0